import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeAnalyticalActivitiesByStudentsColumns = (): IColumn[] => {
  const { getLegends } = useLegends();

  return [
    {
      title: getLegends('GRUPO', false),
      dataKey: 'group',
      width: 270,
    },
    {
      title: getLegends('LOCAL_ESTAGIO', false),
      dataKey: 'place',
      width: 200,
    },
    {
      title: 'Tarefa',
      dataKey: 'task',
      width: 240,
      cellRenderer: ({ rowData }) => {
        return (
          <p className="d-flex flex-column mb-0">
            <span>{rowData?.task}</span>
            {rowData?.subTasks?.map((subTask, subIndex) => (
              <div className="d-flex ms-1" key={subIndex}>
                <span className="text-muted fs-10">
                  - {subTask.task}: {subTask.content}
                </span>
              </div>
            ))}
          </p>
        );
      },
    },
    {
      title: 'Inicio',
      dataKey: 'started',
    },
    {
      title: 'Término',
      dataKey: 'finished',
    },
    {
      title: 'Tempo',
      dataKey: 'workload',
    },
    {
      title: 'Status',
      dataKey: 'activityStatus',
    },
    {
      title: 'Validação',
      dataKey: 'validation',
    },
  ];
};
